import { render, staticRenderFns } from "./ImageGalleryModal.vue?vue&type=template&id=3bb81e7e&"
import script from "./ImageGalleryModal.vue?vue&type=script&lang=ts&"
export * from "./ImageGalleryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports